"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _cookie = require("@/utils/cookie");
var _user = require("@/api/user");
var _hike = require("@/api/hike");
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { writeGaEvent } from '@/utils/ga'
// import { userEvent } from '@/lifehikes-init-data'
// import { truncate } from '@/filters'
// const defaultValue = []
var _default = exports.default = {
  name: 'HikeBenchmarkScoreChecking',
  data() {
    return {
      fullscreenloading: false,
      isReady: false,
      hike: null,
      myHikeTeams: [],
      tasks: [],
      taskStatus: [],
      raterList: [],
      stages: []
    };
  },
  async created() {
    const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
    this.reportType = this.$route.query.type === 'benchmark' ? 'benchmark' : 'summit';
    /*
    await this.getHike()
    await this.getRaterList()
    await this.getHikeParticipants()
    await this.getHikeTaskStatus()
    */
    await this.initData();
    this.isReady = true;
  },
  computed: {
    ...(0, _vuex.mapGetters)(['uuid'])
  },
  methods: {
    checkPermission: _permission.default,
    async initData() {
      // map array to promises
      const promise1 = this.getHike();
      const promise2 = this.getRaterList();
      const promise3 = this.getHikeParticipants();
      const promise4 = this.getHikeTaskStatus();

      // wait until all promises are resolved
      await Promise.all([promise1, promise2, promise3, promise4]);
    },
    getHike() {
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _hike.getHikeById)(token, id).then(response => {
        this.hike = response.data;
        if (this.hike.stages) {
          for (var i = 0; i < this.hike.stages.length; i++) {
            if (this.hike.stages[i].type === this.reportType) {
              this.stages.push(this.hike.stages[i]);
            }
          }
        }
        this.loading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-getHikeById-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    async getHikeParticipants() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      await (0, _hike.getParticipant)(token, id).then(response => {
        var participants = response.data.rows;
        this.myHikeTeams = participants.map(p => _lodash.default.pick(p, ['uuid', 'familyName', 'givenName', 'email']));
        // console.log('My Teams', this.myHikeTeams)
      }).catch(error => {
        (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    async getRaterList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const query = {
        page: 1,
        limit: 200,
        role: 'otr-rater',
        sort: 'givenName'
      };
      (0, _user.getUserList)(token, query).then(response => {
        // this.list = response.data.items
        this.raterList = response.data.rows.map(s => {
          return {
            uuid: s.uuid,
            name: `${s.givenName} ${s.familyName}`
          };
        });
      }).catch(error => {
        (0, _log.showDebugLog)('GetUserList-api-error', error);
      });
    },
    async getHikeTaskStatus() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      await (0, _hike.getTaskStatus)(token, id).then(response => {
        //console.log('response', response.data)
        this.tasks = response.data.tasks;
        this.taskStatus = response.data.jobStatus;
        //console.log('all task', this.tasks)
      }).catch(error => {
        (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    getUserProgressHtml(uuid, type) {
      var style = 'report-open';
      var symbol = '&#x2718;';
      var html = "";
      var task = _lodash.default.find(this.tasks, function (t) {
        return t.userUuid === uuid && t.stageType === type;
      });
      if (task) {
        style = task.noOfVideoUpload === task.totalNoOfVideo ? 'report-complete' : 'report-open';
        symbol = task.noOfVideoUpload === task.totalNoOfVideo ? "&#10003;" : "&#x2718;";
        html = `<span class="${style}"> ${symbol} ${task.noOfVideoUpload} / ${task.totalNoOfVideo} Video(s)</span>`;
      } else {
        html = `<span class="${style}"> ${symbol} 0 / 0 Video(s)</span>`;
      }
      return html;
    },
    getTaskStatusHtml(uuid, type) {
      var task = _lodash.default.find(this.tasks, function (t) {
        return t.userUuid === uuid && t.stageType === type;
      });
      var taskStatus = _lodash.default.filter(this.taskStatus, function (t) {
        return t.userUuid === uuid && t.stageType === type;
      });
      var style = 'report-open';
      var symbol = "&#x2718;";
      var assignedRaterName = [];
      var ratingStyle = 'report-open';
      var ratingSymbol = "&#x2718;";
      var noOfRater = 0;
      var noOfAssignedRater = 0;
      // console.log('Task', task)
      // console.log('taskStatus', taskStatus)

      // task assign progress
      if (task) {
        noOfRater = task.noOfRater ? task.noOfRater : 0;
        noOfAssignedRater = task.noOfAssignedRater ? task.noOfAssignedRater : 0;
      }
      if (task) {
        style = noOfRater === noOfAssignedRater ? 'report-complete' : 'report-open';
        symbol = noOfRater === noOfAssignedRater ? "&#10003;" : "&#x2718;";
        assignedRaterName = task.assignTo.map(this.getUserName);
      }

      // rating video progress
      var totalRatingRater = 0;
      var ratingCompleteRater = [];
      for (var i = 0; i < taskStatus.length; i++) {
        if (taskStatus[i].jobStatus === "complete") {
          totalRatingRater += 1;
          ratingCompleteRater.push(this.getUserName(taskStatus[i].raterId));
        }
      }
      if (task) {
        ratingStyle = totalRatingRater === noOfRater ? 'report-complete' : 'report-open';
        ratingSymbol = totalRatingRater === noOfRater ? "&#10003;" : "&#x2718;";
      } else {
        ratingStyle = 'report-open';
        ratingSymbol = '&#x2718;';
      }

      //ratingCompleteRater.join(', ')

      return `<div class="${style}"> ${symbol} ${noOfAssignedRater} / ${noOfRater} Task(s) - (${assignedRaterName.join(', ')})</div>` + `<div class="${ratingStyle}"> ${ratingSymbol} ${totalRatingRater} / ${noOfRater} Rating(s) - (${ratingCompleteRater.join(', ')})</div>`;
    },
    getUserName(uuid) {
      var staff = this.raterList ? this.raterList.find(u => u.uuid === uuid) : null;
      if (staff) {
        return staff ? staff.name : '-';
      } else {
        return "Not a rater";
      }
    },
    calculateSummaryHtml() {
      var totalBenchmarkTask = 0,
        totalBenchmarkTaskAssign = 0,
        totalBenchmarkRating = 0;
      var totalSummitTask = 0,
        totalSummitTaskAssign = 0,
        totalSummitRating = 0;
      for (var i = 0; i < this.tasks.length; i++) {
        if (this.tasks[i].stageType === 'benchmark') {
          if (this.tasks[i].totalNoOfVideo > 0 && this.tasks[i].totalNoOfVideo === this.tasks[i].noOfVideoUpload) {
            totalBenchmarkTask = totalBenchmarkTask + this.tasks[i].noOfRater;
            totalBenchmarkTaskAssign = totalBenchmarkTaskAssign + this.tasks[i].noOfAssignedRater;
          }
        }
        if (this.tasks[i].stageType === 'summit') {
          if (this.tasks[i].totalNoOfVideo > 0 && this.tasks[i].totalNoOfVideo === this.tasks[i].noOfVideoUpload) {
            totalSummitTask = totalSummitTask + this.tasks[i].noOfRater;
            totalSummitTaskAssign = totalSummitTaskAssign + this.tasks[i].noOfAssignedRater;
          }
        }
      }
      for (var j = 0; j < this.taskStatus.length; j++) {
        if (this.taskStatus[j].stageType === 'benchmark') {
          if (this.taskStatus[j].jobStatus === 'complete') totalBenchmarkRating = totalBenchmarkRating + 1;
        }
        if (this.taskStatus[j].stageType === 'summit') {
          if (this.taskStatus[j].jobStatus === 'complete') totalSummitRating = totalSummitRating + 1;
        }
      }
      return `<div><u>Summary</u></div>` + `<div>Total Tasks(Benchmark): <u> ${totalBenchmarkTask}</u></div>` + `<div>Total Assigned Tasks(Benchmark): <u>${totalBenchmarkTaskAssign}</u></div>` + `<div>Total Rated Tasks(Benchmark): <u>${totalBenchmarkRating}</u></div>` + `<div>-----------------------------------------------------------</div>` + `<div>Total Tasks(Summit): <u>${totalSummitTask}</u></div>` + `<div>Total Assigned Tasks(Summit): <u>${totalSummitTaskAssign}</u></div>` + `<div>Total Rated Tasks(Summit): <u>${totalSummitRating}</u></div>`;
    },
    backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push(`/hike/edit/${id}`);
    }
  }
};